import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import FolderCreationPanel from '../../components/FolderCreationPanel';

const mapStateToProps = (state: StoreState) => {
	const { folderCreationPanel } = state;
	const { isOpen, name, useSelection } = folderCreationPanel;
	return { isOpen, name, useSelection };
};

export default connect(mapStateToProps)(FolderCreationPanel);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/FolderCreationPanel/index.ts